import { ApiDashboardSettingsResponse, ApiLinkingImageResponse } from '../../../api/core/models';
import { conditionallyPrefixImagesWithFilesUrl } from '../../../functions/utilities/img-url-utility';
import { ClientBoardV2 } from '../model';

export function dashboardSettingsToPointOfEntrySettings(
  footerLogos: ApiLinkingImageResponse[],
  baseUrlFiles: string,
  dashboardSettings?: ApiDashboardSettingsResponse
): ClientBoardV2['boardSettings']['pointOfEntrySettings'] {
  if (!dashboardSettings) {
    return undefined;
  }
  return {
    header: {
      boardTitle: dashboardSettings.title,
      country: dashboardSettings.rootLocation,
      tagline: dashboardSettings.aboutTitle,
      taglineSubText: dashboardSettings.goalDescription,
      backgroundImage: {
        large: conditionallyPrefixImagesWithFilesUrl(dashboardSettings.splashScreenBackgroundImageUrl, baseUrlFiles),
      },
      backgroundImageCredits: dashboardSettings.splashScreenBackgroundImageCredits,
      about: dashboardSettings.about,
    },
    footer: {
      bodyLeft: dashboardSettings.footerBodyLeft,
      bodyRight: dashboardSettings.footerBodyRight,
      images:
        footerLogos.map((logo) => ({
          sourceURL: logo.imageUrl,
          id: logo.id,
          ...(logo.destinationUrl ? { destinationURL: logo.destinationUrl } : {}),
        })) ?? [],
    },
  };
}
